// src/dialog/src/dialog-elements/DialogTrigger.tsx
import { Trigger } from "@radix-ui/react-dialog";
import { jsx } from "react/jsx-runtime";
var DialogTrigger = ({ children, ...rest }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  /* @__PURE__ */ jsx(Trigger, { ...rest, children })
);

export {
  DialogTrigger
};
